<template lang="html">
    <gcmcn-layout
        title="ALL GROUPS"
        custom-class="taker-group-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            @click="onTakerGroupCreate"
        >
            Add group
        </el-button>

        <el-row
            :gutter="20"
            class="main-content gcmcn-separator"
        >
            <el-col
                :span="12"
            >
                <gcmcn-filters
                    ref="gcmcn-filters"
                    :filter-values="[selectedSortType, searchFilter, selectedEntitiesForFilter]"
                    @reset-filters="resetFilters"
                >
                    <dropdown
                        name="Sort"
                        :multiple="false"
                        :list="$store.getters.sortTypeList"
                        itemName="name"
                        itemValue="value"
                        :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                        @on-select-item="selectedSortType = $event"
                    ></dropdown>
                    <dropdown
                        name="Entities"
                        :multiple="true"
                        :list="$store.getters.entities"
                        itemName="display_name"
                        itemValue="uid"
                        :itemsSelected="selectedEntitiesForFilter"
                        @on-select-item="onSelectEntities"
                    ></dropdown>
                    <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                </gcmcn-filters>
                <div style="overflow-y: scroll;" :style="{height: `calc(100vh - ${usedHeight}px)`}">
                    <template v-if="filteredTakerGroups.length > 0">
                        <taker-group
                            v-for="takerGroup in filteredTakerGroups"
                            :key="takerGroup.uid"
                            :taker-group="takerGroup"
                            :selected-taker-group-uid="selectedTakerGroupUid"
                            @on-select-taker-group="onSelectTakerGroup"
                        ></taker-group>
                    </template>
                    <template v-else>
                        <div class="list-empty">No taker group</div>
                    </template>
                </div>
            </el-col>
            <el-col
                :span="12"
                :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                style="overflow: auto;"
            >
                <taker-group-form
                    v-if="displayFormView"
                    :taker-group="relatedSelectedTakerGroup"
                    @leave-form-view="displayFormView = false"
                >
                </taker-group-form>
                <taker-group-details
                    v-else-if="selectedTakerGroupUid"
                    :taker-group="relatedSelectedTakerGroup"
                    @on-taker-group-update="onTakerGroupUpdate"
                    @on-group-deleted="selectedTakerGroupUid = ''"
                ></taker-group-details>
            </el-col>
        </el-row>
    </gcmcn-layout>
</template>

<script>

import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import { mapGetters } from 'vuex';
import {
    GcmcnFilters,
    SearchFilter,
    Dropdown,
} from 'gcmcn-common';
import TakerGroup from './taker-group.vue';
import TakerGroupDetails from './taker-group-details.vue';
import TakerGroupForm from './taker-group-form.vue';
export default {

    components: {
        GcmcnLayout,
        GcmcnFilters,
        TakerGroup,
        SearchFilter,
        Dropdown,
        TakerGroupDetails,
        TakerGroupForm,
    },

    props: {

    },

    data (){
        return {
            selectedSortType: '',
            searchFilter: '',
            selectedTakerGroupUid: '',
            displayFormView: false,
            usedHeight: 0
        };
    },

    computed: {
        ...mapGetters([
            'windowWidth',
            'selectedEntitiesForFilter'
        ]),
        filteredTakerGroups (){
            let takerGroups = this.$store.getters.takerGroups.slice();
            if(this.selectedSortType){
                takerGroups.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    takerGroups.reverse();
                }
            }
            if(this.searchFilter){
                takerGroups = takerGroups.filter((takerGr) => takerGr.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            if(this.selectedEntitiesForFilter.length > 0){
                takerGroups = takerGroups.filter((takerGr) => this.selectedEntitiesForFilter.includes(takerGr.scopes.entity_uid));
            }
            return takerGroups;
        },

        relatedSelectedTakerGroup (){
            return this.$store.getters.takerGroups.find((takerGr) => takerGr.uid === this.selectedTakerGroupUid) || null;
        },
    },

    watch:{
        windowWidth() {
            this.computeFilterHeight();
        }
    },
    mounted (){
        this.computeFilterHeight();
    },

    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },

        onTakerGroupCreate() {
            this.selectedTakerGroupUid = '';
            this.displayFormView = true;
        },
        onTakerGroupUpdate() {
            this.displayFormView = true;
        },
        onSelectTakerGroup (takerGroup){
            if(this.displayFormView) this.displayFormView = false;
            this.selectedTakerGroupUid = takerGroup.uid;
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
        onSelectEntities (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/RightGroup/index.vue